import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import ContentBlocks from "../components/ContentBlocks";
import SEO from "../components/SEO";
import { Reveal } from "../components/Reveal";
import { Badge } from "../components/Pill";

export default function PageView() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);

  useEffect(() => {
    setPage(null);
    api(`/pages/${slug}`).then(setPage).catch(() => setPage(false));
  }, [slug]);

  if (page === false) {
    return (
      <main className="min-h-screen bg-cream pt-40 px-6 text-center" data-testid="page-not-found">
        <h1 className="font-display uppercase text-4xl text-ink">Page not found.</h1>
      </main>
    );
  }

  if (!page) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <p className="font-elegant italic text-3xl text-gold animate-pulse">The Brides of India</p>
      </div>
    );
  }

  return (
    <main data-testid="custom-page" className="bg-cream pt-36 pb-24">
      <SEO title={page.title} description={(page.content || "").slice(0, 155)} />
      <div className="max-w-3xl mx-auto px-6">
        <Reveal><Badge tone="gold">The Brides of India</Badge></Reveal>
        <Reveal delay={0.1}>
          <h1 data-testid="custom-page-title" className="mt-6 font-display uppercase text-4xl md:text-5xl lg:text-6xl text-ink leading-[0.98]">
            {page.title}
          </h1>
        </Reveal>
        <div className="mt-12">
          <ContentBlocks content={page.content} />
        </div>
      </div>
    </main>
  );
}
